<template>
  <div
    class="Authoritative-certification-content-item-main"
    :class="{ 'Authoritative-certification-content-item-main-mobile': isMobile }"
  >
    <img class="left-img" :src="data.imgUrl" alt="" />
    <div class="main">
      <div class="main-title">{{ data.title }}</div>
      <div class="main-content">{{ data.content }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AuthoritativeCertificationContentItem",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.Authoritative-certification-content-item-main {
  display: flex;
  margin-bottom: calc($multiple * 71px);
  margin-right: calc($multiple * 56px);
  .left-img {
    width: calc($multiple * 79px);
    height: calc($multiple * 79px);
    background-repeat: no-repeat;
  }
  .main {
    position: relative;
    .main-title {
      color: #000000;
      font-size: calc($multiple * 16px);
      line-height: calc($multiple * 22px);
      letter-spacing: 1px;
      font-family: PingFangTC-Regular, PingFangTC;
      padding: calc($multiple * 20px) 0 calc($multiple * 10px) calc($multiple * 22px);
    }
    .main-content {
      font-size: calc($multiple * 14px);
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #666666;
      line-height: calc($multiple * 20px);
      padding-left: calc($multiple * 22px);
    }
  }
  .main::after {
    content: "";
    position: absolute;
    top: 0;
    left: calc($multiple * 21px);
    /* bottom: -.08rem; */
    /* left: 50%; */
    /* transform: translate(-50%); */
    width: calc($multiple * 46px);
    height: calc($multiple * 5px);
    background: linear-gradient(180deg, #4db0ff 0%, #81aaff 100%);
    border-radius: 3px;
  }
}
.Authoritative-certification-content-item-main-mobile {
  margin: 1.75rem 0rem 0rem 0rem;
  margin-bottom: 0;
  margin-top: 1.75rem;
  .left-img {
    width: 3.45rem;
    height: 3.45rem;
    background-repeat: no-repeat;
  }
  .main {
    position: relative;
    .main-title {
      width: 100%;
      color: #000000;
      font-size: 0.72rem;
      letter-spacing: 1px;
      padding: 0.47rem 0 0.15rem 0.62rem;
      line-height: 1.02rem;
    }
    .main-content {
      margin-top: 0.72rem;
      font-size: 0.61rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8b8b8b;
      line-height: 0.98rem;
      letter-spacing: 0.05rem;
      padding-left: 0.62rem;
    }
  }
  .main::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0.62rem;
    width: 2.3rem;
    height: 0.162rem;
    background: linear-gradient(180deg, #4db0ff 0%, #81aaff 100%);
    border-radius: 0.135rem;
  }
}
/* .Manage-process-content-item-main {
    width: 5.05rem;
    height: 5.53rem;
    background: url('~assets/images/privacyProtect/process-bg1.png') no-repeat;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title {
    font-size: 0.35rem;
    width: 4.68rem;
    height: 1.62rem;
    font-family: AlibabaPuHuiTi_2_75_SemiBold;
    color: #000000;
    line-height: 0.49rem;
    margin-bottom: 0.45rem;
    position: relative;
    background: #F6FAFF;
    border-radius: 8px 8px 0px 0px;
    text-align: center;
    padding-top: .86rem;
  }
  .title::after {
    content: '';
    position: absolute;
    bottom: -.08rem;
    left: 50%;
    transform: translate(-50%);
    width: 1.11rem;
    height: 0.08rem;
    background: linear-gradient(180deg, #4db0ff 0%, #81aaff 100%);
    border-radius: 0.04rem;
  }
  .contents {
    font-size: 0.19rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    line-height: 0.48rem;
  }
  .Manage-process-content-item-main-mobile {
    width: 18.59rem;
    height: auto;
    padding: 1.74rem 0 3.1rem 0;
    background-position-y: bottom;
    margin-top: -1.5rem;
    .title {
      font-size: .82rem;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 1.13rem;
      margin-bottom: 0.79rem;
      position: relative;
    }
    .title::after {
      content: '';
      position: absolute;
      bottom: -0.46rem;
      left: 50%;
      transform: translate(-50%);
      width: 3.69rem;
      height: 0.15rem;
      border-radius: 0.15rem;
    }
    .contents {
      font-size: 0.61rem;
      line-height: .98rem;
      letter-spacing: .05rem;
    }
  } */
</style>
